/**
 * Strict English-only rules for Spacey voice mode.
 * Keep in sync with AgentVoiceLanguagePolicy.java on the backend.
 */

export const VOICE_ENGLISH_ONLY_BLOCK = [
  'ABSOLUTE RULE — SPOKEN OUTPUT LANGUAGE (VOICE MODE):',
  'Speak ONLY English. Every word, every turn, including this greeting — zero exceptions.',
  'NEVER use Sinhala (e.g. ayubowan, kohomada, istuti), Tamil, or any non-English language — even if the user speaks another language or transcripts look non-English.',
  'Sri Lanka context means workspace location — NOT Sinhala speech. Do not mirror the user\'s language.',
  'If input is unclear or accented, assume English and reply in English.',
].join(' ');

/** Indic scripts Spacey must never speak (Sinhala, Tamil, Devanagari, Kannada). */
export const NON_ENGLISH_SPOKEN_SCRIPT = /[\u0B80-\u0BFF\u0C00-\u0C7F\u0D80-\u0DFF\u0900-\u097F]/;

export const containsNonEnglishSpokenScript = (text) => (
  NON_ENGLISH_SPOKEN_SCRIPT.test(String(text || ''))
);

export const buildFallbackEnglishGreetingScript = (userContext = {}) => {
  const name = (userContext.userName || '').trim().split(/\s+/)[0];
  if (name) {
    return `Hey ${name}! I'm Spacey from MillionSpaces — I help people find workspaces across Sri Lanka. What are you looking for today?`;
  }
  return 'Hey! I\'m Spacey from MillionSpaces — I help people find workspaces across Sri Lanka. What are you looking for today?';
};

/** Instructions for Spacey's one-time spoken hello when voice mode connects. */
export const buildVoiceGreetingInstructions = (userContext = {}) => {
  const name = (userContext.userName || '').trim().split(/\s+/)[0];
  const nameHint = name ? `Address them as ${name}. ` : '';
  const example = buildFallbackEnglishGreetingScript(userContext);
  return (
    `${VOICE_ENGLISH_ONLY_BLOCK} `
    + `${nameHint}Greet the user now in exactly two short spoken sentences. `
    + 'You are Spacey from MillionSpaces — warm, friendly, and a little playful, like a natural voice chat. '
    + 'Say hi in ENGLISH ONLY, mention you help find workspaces in Sri Lanka, and ask what they are looking for. '
    + 'Sound relaxed and human, not scripted. Do not call any tools. '
    + `Speak ONLY the following idea in your own warm English words (never translate to Sinhala or Tamil): "${example}"`
  );
};

/** Retry prompt: verbatim English script when the model drifts to another language. */
export const buildVerbatimEnglishGreetingInstructions = (userContext = {}) => (
  `${VOICE_ENGLISH_ONLY_BLOCK} `
  + 'Speak EXACTLY the following English text word-for-word. Do not add, remove, or translate any words: '
  + `"${buildFallbackEnglishGreetingScript(userContext)}"`
);
